export const VENUS_DOC_GASLESS_URL = 'https://docs-v4.venus.io/guides/gasless-transactions-zksync';
